import { tools } from './../helpers/tools';
import { settings } from './../settings';
import { AuthResponse, CollectResponse } from '../api/models';
import ajax from '../api/ajax';

class BankId {
    constructor(domain) {
        this.url = {
            domain: domain,
            path: 'authentication/bankid/',
        };
    }
    
    init() {
        this.url.domain = settings.settings.acf[`bankid_api_url`];
    }

    /**
     * Initiate the auth process using bank id.
     * @param {string} personalnumber
     * @param {function} collectUpdated - Callback to run when collect updates
     * @return {Promise<AuthResponse>} promise
     */
    auth(personalnumber, collectUpdated) {
        const self = this;

        return new Promise((resolve, reject) => {
            const interval = 2000;            
        
            return ajax.post(self, `authenticate`, true, JSON.stringify({ personalNumber: personalnumber })).then((auth) => {
                (function trycollect() {
                    self.collect(auth.orderRef).then(function (collect) {

                        if (typeof collectUpdated === 'function')
                            collectUpdated(collect);

                        if (collect.result.response.status == 'failed') {
                            reject(collect);

                        } else if (collect.result.response.status == 'complete') {
                            resolve(collect);

                        } else if (collect.result.response.status == 'pending') {
                            setTimeout(trycollect, interval);
                            
                        }
                    }).catch((response) => {
                        reject(response);
                    });
                })();
            }).catch((error) => {
                const response = new AuthResponse().failed(error);

                tools.handleError(self, response);

                reject(response);
            });
        });
    }

    /**
     * Check status of the auth process using bank id.
     * @param {string} orderRef
     * @return {Promise<CollectResponse>} promise
     */
    collect(orderRef) {
        const self = this;
        
        return new Promise((resolve, reject) => {
            return ajax.post(self, `collect?orderRef=${orderRef}`, true).then((collect) => {
                const response = new CollectResponse(collect);

                if (collect) {
                    resolve(response);
                } else {
                    reject(response);
                }
            }).catch((error) => {
                const response = new CollectResponse().failed(error);

                tools.handleError(self, response);

                reject(response);
            });
        });
    }
}

export let bankid = new BankId();


// WEBPACK FOOTER //
// ./scripts/booking/api/bankid.js